<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: "Dida-Pro",
  mounted() {
    /**
     * this is to override the layout config using saved data from localStorage
     * remove this to use config only from static json (@/core/config/layout.config.json)
     */  
  }
};
</script>
